/*eslint-disable*/ export const messages = JSON.parse("{\"card.button.text\":[\"Velg\"]}");
//# sourceMappingURL=messages.mjs.map